module.exports = __webpack_public_path__ + "static/media/industries-concrete-s.2fdfeebb.jpg";